<template>
  <div class="layout-content-list">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>运单管理</span>
      </el-breadcrumb-item>

      <el-breadcrumb-item :to="{ path: '/tasklist' }">任务单</el-breadcrumb-item>
      <el-breadcrumb-item>异常车辆列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-panel">
      <div class="toolbar-item" id="auto-0">
        <span class="item-label">筛选条件</span>
        <el-input
          v-model.trim="filter.keyword"
          style="width: 210px"
          :maxlength="ordernumberKeywordLimit"
          placeholder="搜索车牌号、司机、手机号"
        >
        </el-input>
      </div>

      <div class="toolbar-item" id="auto-1">
        <span class="demonstration">运单状态</span>
        <el-select v-model="filter.orderState" placeholder="请选择" style="width: 148px">
          <el-option v-for="item in orderStatusArr" :label="item.label" :value="item.value" :key="item.value">
          </el-option>
        </el-select>
      </div>

      <div class="toolbar-item">
        <el-button type="primary" size="small" @click="handleSearch" id="auto-2">筛选</el-button>
      </div>
    </div>
    <div class="btn-group-box clearfix">
      <div class="fl">
        <span class="btn-left-txt"> 异常车辆列表 </span>
      </div>
      <div class="fr">
        <el-button type="primary" size="small" @click="handleSendBatch" id="auto-3" :disabled="tableData.total === 0"
          >批量通知司机</el-button
        >
      </div>
    </div>
    <div class="table-custom-box" id="auto-4">
      <el-table :data="tableData.data" border>
        <el-table-column prop="orderNumber" label="运单号" min-width="240">
          <template v-slot="scope">
            <span class="font-green pointer" @click="showOrderDetail(scope.row)"
              >{{ scope.row.orderNumber
              }}<span v-if="scope.row.logisticsCompany" class="task-order-tag"
                ><i></i>{{ scope.row.logisticsCompany | filterTaskOrderTag }}</span
              ></span
            >
          </template>
        </el-table-column>
        <el-table-column prop="plateNumber" label="车牌号" min-width="160">
          <template v-slot="scope">
            {{ scope.row.plateNumber }}
            <span
              v-if="scope.row.plateNumberListType"
              :class="[scope.row.plateNumberListType == 1 ? 'yellow-tag' : 'white-tag']"
              >{{ scope.row.plateNumberListType == 1 ? '黄名单' : '白名单' }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="driverName" label="司机" min-width="160">
          <template v-slot="scope">
            {{ scope.row.driverName }}
            <span
              v-if="scope.row.driverNameListType"
              :class="[scope.row.driverNameListType == 1 ? 'yellow-tag' : 'white-tag']"
              >{{ scope.row.driverNameListType == 1 ? '黄名单' : '白名单' }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="driverPhone" label="手机号" min-width="120"> </el-table-column>
        <el-table-column prop="loadAddress" label="装货地" min-width="125" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="unloadAddress" label="卸货地" min-width="125" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="signLoadTime" label="装货签到时间" min-width="160"> </el-table-column>
        <el-table-column prop="travelLengthTime" label="在途时长" min-width="120"> </el-table-column>
        <el-table-column prop="trackStateDesc" label="轨迹状态" min-width="90"> </el-table-column>
        <el-table-column prop="orderStateDesc" label="运单状态" min-width="90"> </el-table-column>
        <el-table-column label="操作" width="220" align="center">
          <template v-slot="scope">
            <el-button type="text" size="small" @click="handleClick(scope.row)" class="font-blue">查看轨迹</el-button>
            <el-dropdown
              trigger="click"
              class="ml-6"
              v-if="scope.row.driverJoinYellow == false || scope.row.vehicleJoinYellow == false"
            >
              <el-button type="text"> 加入黄名单<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-if="scope.row.vehicleJoinYellow == false"
                  @click.native="handleAddYellowList(scope.row, 'plate')"
                  >车辆加入黄名单</el-dropdown-item
                >
                <el-dropdown-item
                  v-if="scope.row.driverJoinYellow == false"
                  @click.native="handleAddYellowList(scope.row, 'driver')"
                  >司机加入黄名单</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <el-button v-if="scope.row.onTheWayCheck" type="text" size="small" @click="handleSendMsg(scope.row)"
              >短信提醒</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-fix">
      <el-pagination
        :page-size="pageSize"
        :current-page.sync="currentPage"
        :total="tableData.total"
        @current-change="currentChange"
        layout="total, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:4
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import Vue from 'vue';
import { WUYI } from '@/api/common';
import axiosNew from '@/api/axiosNew';
import orderNewApi from '@/api/order.new.api';
import logisticsApi from '@/api/logistics.api';
export default {
  name: 'AbnormalCar',
  data: function () {
    return {
      currentPage: 1,
      pageSize: 20,
      companyPhone: WUYI.currentData.company.companyphone,
      companyCode: WUYI.currentData.company.companycode,
      holdercode: '',
      filter: {
        keyword: '',
        orderState: 0
      },
      cache: {},
      tableData: {
        data: [],
        total: 0
      },
      orderStatusArr: [
        { label: '全部', value: 0 },
        { label: '待装货签到', value: 1 },
        { label: '待卸货签到', value: 2 }
      ]
    };
  },
  created: function () {
    this.handleSearch();
  },
  methods: {
    handleSearch() {
      this.cache = { ...this.filter };
      this.currentPage = 1;
      this.axiosRequest();
    },
    currentChange(val) {
      this.currentPage = val;
      this.axiosRequest();
    },
    axiosRequest() {
      const options = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ...this.cache
      };
      axiosNew.post(orderNewApi.abnormalVehicleList, options).then(res => {
        this.tableData.data = res.data.data || [];
        this.tableData.total = res.data.total;
      });
    },
    handleClick(item) {
      window.location.href = `./logistics.html#/orderDtlMap/${item.orderNumber}`;
    },
    handleAddYellowList(item, type) {
      let msg = type === 'plate' ? '车牌' : '司机';
      this.$confirm(`确认添加${msg}到黄名单`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          // 加入黄名单
          let postData =
            type == 'driver'
              ? { keyword: item.driverCode, keywordType: 1 }
              : { keyword: item.plateNumber, keywordType: 2 };
          postData.companyCode = this.companyCode;
          postData.companyListType = 2;
          axiosNew.post(logisticsApi.billmanagerAdd, postData).then(res => {
            this.handleSearch();
          });
        })
        .catch(() => {});
    },
    // 单个发短信
    handleSendMsg(item) {
      const options = {
        orderNumber: item.orderNumber,
        companyPhone: this.companyPhone
      };
      axiosNew.post(logisticsApi.onTheWayAbnormalListSendSMS, options).then(res => {});
    },
    // 批量发送短信
    handleSendBatch() {
      this.$confirm(`确认批量通知司机?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          axiosNew.post(orderNewApi.abnormalVehicleBatchSendSMS, { ...this.cache }).then(res => {});
        })
        .catch(() => {});
    },
    showOrderDetail: function (row) {
      // 跳转运单详情
      var url = './orderdetail.html#/' + row.orderNumber;
      window.open(url);
    }
  }
};
</script>
